import * as React from "react";
import Popover from "@amzn/awsui-components-react-v3/polaris/popover";
import {
    getAbbreviatedTimezoneFromIANA, 
    getUTCOffsetFromIANA
} from '../../util/DateUtil';
import { Box } from "@amzn/awsui-components-react-v3";

interface TimezoneHintPopoverProps {
    timezoneIANA: string
}

export const TimezoneHintPopover = (props: TimezoneHintPopoverProps) => {

    const timezoneAbbr = getAbbreviatedTimezoneFromIANA(props.timezoneIANA);
    const timezoneOffset = getUTCOffsetFromIANA(props.timezoneIANA);

    return (
        <Popover
            triggerType="text"
            dismissAriaLabel="close"
            header="Time Zone"
            size="large"
            content={
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Box variant="span">{props.timezoneIANA}</Box>
                    <Box variant="span">({timezoneOffset})</Box>
                </div>
            }>
            ({timezoneAbbr})
        </Popover>
    )
}